import { Component, OnInit } from "@angular/core";
import { Dealer } from "../shared/models/dealer.interface";
import { AdminService } from "./services/admin.service";

@Component({ template: '' })
export abstract class AdminComponent {
  public idiAdmin: boolean = false;

  public selectedDealer: number = null;
  public dealers: Dealer[];
  quoteOnly: boolean = false; 

  constructor(private adminService: AdminService) {
  }

  ngOnInit(): void {
    this.idiAdmin = (AdminService._authNavStatusSource.value == "IDI");

    if (this.idiAdmin) {
      this.adminService.getDealers()
        .subscribe({
          next: (data) => {
            this.selectedDealer = this.adminService.getDealerId();

            this.dealers = data;
          }
        });
    }
    else {
      this.selectedDealer = AdminService._authUserSource.value.dealer_ID;
      this.quoteOnly = AdminService._authUserSource.value.isQuoteOnly;
    }
  }

  public selectDealer(): void {
    this.adminService.setDealerId(this.selectedDealer);
  }
}
